import { createSlice } from "@reduxjs/toolkit";
import { CouponUserState } from "../../interface/interface";

const initialState = (): stateType => {
  return {
    leader: {
      id: "",
      name: "",
      email: "",
    },
    insertCoupon: [],
    insertInvitation: {
      leader: {
        id: "",
        name: "",
        email: "",
      },
      project: {
        id: "",
        title: "",
      },
      list: [],
    },
    certifiFile: {
      isUpload: false,
    },
  };
};

const dataReducer = createSlice({
  name: "data",
  initialState,
  reducers: {
    LeaderChange: (state, { payload }: { payload: LeaderInter }) => {
      state.leader = payload;
    },
    LeaderReset: (state) => {
      state.leader = {
        id: "",
        name: "",
        email: "",
      };
    },
    CertifiUpload: (state) => {
      state.certifiFile.isUpload = !state.certifiFile.isUpload;
    },
    InsertCouponChange: (
      state,
      { payload }: { payload: CouponUserState[] | never }
    ) => {
      state.insertCoupon = payload;
    },
    InvitationLaeder: (state, { payload }: { payload: LeaderInter }) => {
      state.insertInvitation.leader = payload;
    },
    InvitationProject: (
      state,
      { payload }: { payload: { id: string; title: string } }
    ) => {
      state.insertInvitation.project = payload;
    },
    InvitationList: (
      state,
      { payload }: { payload: CouponUserState[] | never }
    ) => {
      state.insertInvitation.list = payload;
    },
  },
});

export const {
  LeaderChange,
  InsertCouponChange,
  InvitationLaeder,
  InvitationList,
  InvitationProject,
  CertifiUpload,
  LeaderReset,
} = dataReducer.actions;

export default dataReducer.reducer;

type stateType = {
  leader: LeaderInter;
  insertCoupon: CouponUserState[] | never[];
  insertInvitation: InvitationInter;
  certifiFile: CertifiFileType;
};
export interface CertifiFileType {
  isUpload: boolean;
}
export interface LeaderInter {
  id: string;
  name: string;
  email: string;
}

export interface InvitationInter {
  leader: LeaderInter;
  project: {
    id: string;
    title: string;
  };
  list: CouponUserState[] | never[];
}
